export const CLEAR_PROMOTED_SEARCH_RESULTS = 'CLEAR_PROMOTED_SEARCH_RESULTS';
export const LOAD_PROMOTED_SEARCH_RESULTS_FAIL = 'LOAD_PROMOTED_SEARCH_RESULTS_FAIL';
export const LOAD_PROMOTED_SEARCH_RESULTS_REQUEST = 'LOAD_PROMOTED_SEARCH_RESULTS_REQUEST';
export const LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS = 'LOAD_PROMOTED_SEARCH_RESULTS_SUCCESS';
